var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroModalDurationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.073,
    height: 43.073,
    viewBox: "0 0 43.073 43.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(-489 -680)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "clock-five",
    d: "M21.537,43.073A21.537,21.537,0,1,1,43.073,21.537,21.561,21.561,0,0,1,21.537,43.073Zm0-39.484A17.947,17.947,0,1,0,39.484,21.537,17.968,17.968,0,0,0,21.537,3.589Zm6.1,24.773-4.3-7.315V8.974H19.742V22.025l4.8,8.155,3.1-1.82Z",
    transform: "translate(489 680)",
    fill: "#d9d9d9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroModalDurationIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroModalDurationIcon.827f6ae28fde49161293a37997a4e27e.svg";
export { ForwardRef as ReactComponent };